import { createActionGroup, props } from '@ngrx/store';
import { CreditAccount, UserType } from '@enrollhere/classes';

export const AccountActions = createActionGroup({
  source: 'Account',
  events: {
    'Load Accounts': props<{ agencyId: string; userType?: UserType }>(),
    'Load Accounts Success': props<{
      accounts: CreditAccount[];
      agencyId: string;
      userType?: UserType;
    }>(),
    'Load Accounts Failure': props<{ error: any }>(),
    'Load Account': props<{
      agencyId: string;
      accountId: string;
      userType?: UserType;
    }>(),
    'Load Account Success': props<{
      account: CreditAccount;
      agencyId: string;
      userType?: UserType;
    }>(),
    'Load Account Failure': props<{ error: any }>(),
    'Add Account': props<{
      account: CreditAccount;
      agencyId: string;
      userType?: UserType;
    }>(),
    'Add Account Success': props<{
      account: CreditAccount;
      agencyId: string;
    }>(),
    'Add Account Failure': props<{ error: any }>(),
    'Remove Account': props<{
      agencyId: string;
      accountId: string;
      userType?: UserType;
    }>(),
    'Remove Account Success': props<{
      agencyId: string;
      accountId: string;
      userType?: UserType;
    }>(),
    'Remove Account Failure': props<{ error: any }>(),
    'Update Account': props<{
      agencyId: string;
      accountId: string;
      account: Partial<CreditAccount>;
      userType?: UserType;
    }>(),
    'Update Account Success': props<{
      agencyId: string;
      accountId: string;
      account: Partial<CreditAccount>;
      userType?: UserType;
    }>(),
    'Update Account Failure': props<{ error: any }>(),
  },
});
